export const MIN_OVERRIDE_QUANTITY = 0;
export const MAX_OVERRIDE_QUANTITY = 100;

export const isValidOverrideQuantity = (quantity: number) =>
  quantity >= MIN_OVERRIDE_QUANTITY && quantity <= MAX_OVERRIDE_QUANTITY;
